import { devModeConfig } from '../../app/components/DevMode.helpers';
import { uuid } from '../../app/helpers/flows/HelperFunctions';
import { DevApi } from '../../app/services/ApiService';
import { devConstants as constants } from '../constants';
import { baseAction, toDispatch, wait } from '../utils';
import Swal from 'sweetalert2';

const getTemplates = () => (dispatch, getState) => {
  return baseAction({
    fn: DevApi(getState().auth.token).getTemplates,
    ...constants.GET_TEMPLATES,
    dispatch,
    getState
  });
}

const getPrimitivas = () => (dispatch, getState) => {
  return baseAction({
    fn: DevApi(getState().auth.token).getPrimitivas,
    ...constants.GET_PRIMITIVAS,
    dispatch,
    getState
  });
}

const getOrquestadores = () => (dispatch, getState) => {
  return baseAction({
    fn: DevApi(getState().auth.token).getOrquestadores,
    ...constants.GET_OPERACIONES,
    dispatch,
    getState
  });
}

const selectTab = (index) => (dispatch, getState) => {
  dispatch(toDispatch(constants.SELECT_TAB, index));
  return wait(10);
}

const openTab = (itemOrId) => (dispatch, getState) => {
  dispatch(toDispatch(constants.OPEN_TAB, {data: itemOrId}));
}

const openTabFromOrquestador = (id, type) => (dispatch, getState) => {
  if(!type) return;
  const state = getState().dev;
  const controllerName = devModeConfig[type].controllerName;
  const item = state[controllerName].find(item => item.id === id);
  const fileItem = state.explorer.treeData.find(item => item.id === `${id}-${type}`);
  console.log("openTabFromOrquestador action", {state, id, type, controllerName, item, fileItem});
  dispatch(toDispatch(constants.OPEN_TAB, {data: fileItem}));
}

const updateData = (folder, list, type) => (dispatch, getState) => {
  dispatch(toDispatch(constants.UPDATE_EXPLORER_DATA, {folder, list, type}));
}

const updateDataOpenFiles = () => (dispatch, getState) => {
  dispatch(toDispatch(constants.UPDATE_EXPLORER_DATA_OPEN_FILES, {}));
}

const openTab2 = (item) => (dispatch, getState) => {
  console.log(item);
  return baseAction({
    fn: () => new Promise((resolve, reject) => {
      DevApi(getState().auth.token).getItem(item.metadata.item.id, item.metadata.type)
      .then(response => {
        resolve({data: {...item, data: response.data}});
      })
      .catch(reason => {
        console.log(reason);
        reject("error");
      })
    }),
    ...constants.OPEN_TAB2,
    dispatch,
    getState
  });
  //dispatch(toDispatch(constants.OPEN_TAB, item));
}

const reloadItem = (type, id) => (dispatch, getState) => {
  console.log("action reloadItem", {type, id})
  return baseAction({
    fn: () => new Promise((resolve, reject) => {
      DevApi(getState().auth.token).getItem(id, type)
      .then(response => {
        resolve({data: {id, type, data: response.data}});
      })
      .catch(reason => {
        console.log(reason);
        reject("error");
      })
    }),
    ...constants.RELOAD_ITEM,
    dispatch,
    getState
  });
  //dispatch(toDispatch(constants.OPEN_TAB, item));
}

const reloadLocalItem = (type, id, item) => (dispatch, getState) => {
  dispatch(toDispatch(constants.RELOAD_LOCAL_ITEM, {id, type, data: item}));
}

const closeTab = (tab, force = false) => (dispatch, getState) => {
  if(tab.changed && !force){
    return Swal
      .fire({
        icon: 'question',
        title: `La pestaña ${tab.data.name} tiene cambios sin guardar`,
        html: `¿Quiere cerrar de todas maneras esta pestaña y perder los cambios realizados?`,
        confirmButtonText: 'Sí, perder los cambios',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        showDenyButton: false,
      })
      .then((result) => {
        if (result.isConfirmed) {
          dispatch(toDispatch(constants.CLOSE_TAB, tab.data.id));
        } else if (result.isDenied) {
        }
        return wait(50);
      });
  }
  dispatch(toDispatch(constants.CLOSE_TAB, tab.data.id)); 
  return wait(50);
}

const setExplorerWidth = (value) => (dispatch, getState) => {
  dispatch(toDispatch(constants.SET_EXPLORER_WIDTH, value));
}

const selectNode = (node) => (dispatch, getState) => {
  dispatch(toDispatch(constants.SELECT_NODE, node));
}

const setChangedTab = (index = 0, value = false) => (dispatch, getState) => {
  dispatch(toDispatch(constants.SET_CHANGED_TAB, {index, value}));
  return wait(50, index);
}

const updateTabData = (index = 0, data) => (dispatch, getState) => {
  dispatch(toDispatch(constants.UPDATE_TAB_DATA, {index, data}));
}

const createNewFile = (folderElement, type) => (dispatch, getState) => {
  dispatch(toDispatch(constants.CREATE_NEW_FILE, {folderElement, type}));
}

const cancelNewFile = (id) => (dispatch, getState) => {
  dispatch(toDispatch(constants.CANCEL_NEW_FILE, {id}));
}

const confirmNewFile = (id, name, type) => (dispatch, getState) => {
  const newId = `${id}-${uuid()}`;
  dispatch(toDispatch(constants.CONFIRM_NEW_FILE, {id, name, newId, type}));
  return wait(150, newId);
}

const savedNewFile = (id, data, type) => (dispatch, getState) => {
  dispatch(toDispatch(constants.SAVED_NEW_FILE, {id, data, type}));
}

const getConectionTypes = () => (dispatch, getState) => {
  return baseAction({
    fn: () => DevApi(getState().auth.token).getConectionTypes(),
    ...constants.GET_CONNECTION_TYPES,
    dispatch,
    getState
  });
}

const updateTabTemplate = (index, code) => (dispatch, getState) => {
  dispatch(toDispatch(constants.UPDATE_TAB_TEMPLATE, {index, code}));
}

const updateTabPrimitiva = (index, data) => (dispatch, getState) => {
  dispatch(toDispatch(constants.UPDATE_TAB_PRIMITIVA, {index, data}));
}

const updateTabOrquestador = (index, flowData) => (dispatch, getState) => {
  dispatch(toDispatch(constants.UPDATE_TAB_ORQUESTADOR, {index, flowData}));
}

const selectNodeFile = (id) => (dispatch, getState) => {
  dispatch(toDispatch(constants.SELECT_NODE_FILE, {id}));
  return wait(150, id);
}

const getNodeTypes = () => (dispatch, getState) => {
  return baseAction({
    fn: () => DevApi(getState().auth.token).getNodeTypes(),
    ...constants.GET_NODE_TYPES,
    dispatch,
    getState
  });
}

const setExpandedFolder = (id, expanded) => (dispatch, getState) => {
  dispatch(toDispatch(constants.SET_EXPANDED_FOLDER, {id, expanded}));
}

const postAddItem = (tab, item, type) => (dispatch, getState) => {
  dispatch(toDispatch(constants.POST_ADD_ITEM, {tab, item, type}));
  return wait(150);
// eliminar el elemento abierto
// eliminar el elemento en el explorador d eproyecto (data)
// cerrar el tab de ese elemento
// agregar el elemento nuevo a data
// abrir el elemento en un tab

}

const removeItem = (element) => (dispatch, getState) => {
  console.log("remove item action", {element});
  return Swal
  .fire({
    icon: 'question',
    title: `¿Esta seguro que desea eliminar ${element.name} de forma permanente?`,
    html: `Esta acción no podrá revertirse.`,
    confirmButtonText: 'Sí, eliminar el archivo',
    cancelButtonText: 'Cancelar',
    showCancelButton: true,
    showDenyButton: false,
  })
  .then((result) => {
    if (result.isConfirmed) {
      if(element.metadata.isNewFile){
        dispatch(toDispatch(constants.REMOVE_ITEM.SUCCESS, {element}));
        return wait(50);
      }   
      return baseAction({
        fn: () => new Promise((resolve, reject) =>{
          DevApi(getState().auth.token).removeItem(element.metadata.item, element.metadata.type)
          .then(response => {
              resolve({data:{response, element}});
          })
          .catch(e => console.warn(e))
        }),
        ...constants.REMOVE_ITEM,
        dispatch,
        getState
      });
    } else if (result.isDenied) {
    }
  });

}

const changeNavigatorUrl = (value) => (dispatch, getState) => {
  dispatch(toDispatch(constants.CHANGE_NAVIGATOR_URL, {value}));
  return wait(50);
}

export const devActions = {
  getTemplates,
  getPrimitivas,
  getOrquestadores,
  openTab,
  selectTab,
  closeTab,
  setChangedTab,
  getConectionTypes,
  getNodeTypes,
  setExplorerWidth,
  reloadItem,
  reloadLocalItem,
  updateTabTemplate,
  updateTabPrimitiva,
  updateTabData,
  updateTabOrquestador,
  updateData,
  updateDataOpenFiles,
  openTabFromOrquestador,
  createNewFile,
  cancelNewFile,
  confirmNewFile,
  savedNewFile,
  selectNodeFile,
  setExpandedFolder,
  removeItem,
  postAddItem,
  changeNavigatorUrl,
};

